import type { Sak } from '../classes';
import { SakRoutes } from '../config';

/**
 * Åpner en ekstern lenke (f.eks. en sak i Dalux) i ny fane. Må kalles fra et klikk, ellers blokkeres den.
 */
export const openExternalUrl = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Sender brukeren ut av Kundeportal i samme fane, for videresending uten klikk (f.eks. ved direkte lenke).
 */
export const redirectToExternalUrl = (url: string) => {
    window.location.href = url;
};

/**
 * Dalux-saker lenker direkte til saken i Dalux, alle andre til saksvisningen i Kundeportal.
 */
export const getSakHref = (sak: Sak): string =>
    sak.isDalux ? sak.eksternUrl! : SakRoutes.single(sak.id);

export const filterSakListByIsArchiveAndBygg = (
    sakList: Array<Sak>,
    byggNummer: string,
    archive?: boolean,
): Array<Sak> => {
    const sakListByStatus = filterSakListByIsArchiveAndMerged(
        sakList,
        archive,
        false,
    );
    return filterSakListByByggNummer(sakListByStatus, byggNummer);
};

export const filterSakListByIsArchiveAndMerged = (
    sakList: Array<Sak>,
    archive?: boolean,
    filterOutMerged?: boolean,
): Array<Sak> => {
    const sakListByArchive = sakList.filter(
        (s) =>
            s.isArchived === archive ||
            (!s.isArchived && s.status !== 'Sammenslått'),
    );

    if (filterOutMerged) {
        return sakListByArchive;
    } else {
        return sakListByArchive.filter(
            (s) => s.isArchived === archive || s.status === 'Sammenslått',
        );
    }
};

export const filterSakListByByggNummer = (
    sakList: Array<Sak>,
    byggNummer: string,
): Array<Sak> => {
    const result = sakList.filter((s) =>
        s.sakskategoriNavn?.match(new RegExp('^' + byggNummer + '[^-]')),
    );
    if (result.length > 0) {
        return result;
    }
    return sakList.filter((s) =>
        s.sakskategoriNavn?.match(new RegExp('^\\d{3}-' + byggNummer)),
    );
};

export const getByggNummerFromSakskategoriNavn = (
    sakskategoriNavn: string,
): string => {
    const matches = sakskategoriNavn?.match(/^(\d{3})-?(\d{3})?/);
    if (matches) {
        return matches[2] || matches[1];
    }
    return '';
};
